import React from 'react';
import { useTranslation } from 'react-i18next';

const QUICK_OPS = ['today', 'last_7d', 'last_30d', 'last_90d'];
const QUICK_KEY = { today: 'today', last_7d: 'last7d', last_30d: 'last30d', last_90d: 'last90d' };

export default function DateFilter({ value, onChange }) {
  const { t } = useTranslation();
  const op = value?.op || null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div style={{ display: 'flex', gap: 4 }}>
        {QUICK_OPS.map(q => (
          <button
            key={q}
            aria-pressed={op === q}
            onClick={() => onChange({ op: q })}
            style={{
              ...S.chip,
              background: op === q ? 'var(--accent-dim)' : 'transparent',
              borderColor: op === q ? 'var(--accent)' : 'var(--border)',
              color:       op === q ? 'var(--accent)' : 'var(--text-secondary)',
            }}
          >
            {t(`table.${QUICK_KEY[q]}`)}
          </button>
        ))}
      </div>

      <div style={{ display: 'flex', gap: 4 }}>
        {['before', 'after'].map(o => (
          <button
            key={o}
            aria-pressed={op === o}
            onClick={() => onChange({ op: o, value: value?.value || '' })}
            style={{
              ...S.chip, flex: 1,
              background: op === o ? 'var(--accent-dim)' : 'transparent',
              borderColor: op === o ? 'var(--accent)' : 'var(--border)',
              color:       op === o ? 'var(--accent)' : 'var(--text-secondary)',
            }}
          >
            {t(`table.${o}`)}
          </button>
        ))}
      </div>

      {(op === 'before' || op === 'after') && (
        <input
          aria-label={t('table.rangeStart')}
          type="date"
          value={value?.value || ''}
          onChange={e => onChange({ op, value: e.target.value })}
          style={S.input}
          autoFocus
        />
      )}

      <button
        onClick={() => onChange({ op: 'custom', value: value?.value || '', value2: value?.value2 || '' })}
        style={{
          ...S.chip,
          background: op === 'custom' ? 'var(--accent-dim)' : 'transparent',
          borderColor: op === 'custom' ? 'var(--accent)' : 'var(--border)',
          color:       op === 'custom' ? 'var(--accent)' : 'var(--text-secondary)',
        }}
      >
        {t('table.customRange')}
      </button>

      {op === 'custom' && value?.value && value?.value2 && value.value > value.value2 && <p role="alert">{t('table.invalidRange')}</p>}
      {op === 'custom' && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <label htmlFor="table-date-start">{t('table.rangeStart')}</label>
          <input
            id="table-date-start"
            type="date"
            aria-label={t('table.rangeStart')}
            value={value?.value || ''}
            onChange={e => onChange({ op: 'custom', value: e.target.value, value2: value?.value2 || '' })}
            style={S.input}
          />
          <label htmlFor="table-date-end">{t('table.rangeEnd')}</label>
          <input
            id="table-date-end"
            type="date"
            aria-label={t('table.rangeEnd')}
            min={value?.value || undefined}
            value={value?.value2 || ''}
            onChange={e => onChange({ op: 'custom', value: value?.value || '', value2: e.target.value })}
            style={S.input}
          />
        </div>
      )}
    </div>
  );
}

const S = {
  chip: {
    padding: '4px 8px', border: '1px solid var(--border)',
    borderRadius: 5, fontSize: 11, cursor: 'pointer',
    fontFamily: 'inherit', transition: 'all 0.12s',
    background: 'transparent',
  },
  input: {
    width: '100%', padding: '6px 8px',
    background: 'var(--bg-elevated)', border: '1px solid var(--border)',
    borderRadius: 6, color: 'var(--text-primary)', fontSize: 12,
    fontFamily: 'inherit', boxSizing: 'border-box',
  },
};
